import { Button } from '@repo/ui/components/ui/button'
import { cn } from '@repo/ui/lib/utils'
import type { ReactNode } from 'react'

export function WorkspaceEmptyState({
  badgeIcon,
  actionIcon,
  title,
  description,
  primaryActionLabel,
  onPrimaryAction,
  isBusy = false,
  className,
}: {
  badgeIcon: ReactNode
  actionIcon?: ReactNode
  title: string
  description: string
  primaryActionLabel: string
  onPrimaryAction: () => void
  isBusy?: boolean
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex min-h-[26rem] flex-col items-center justify-center space-y-5 px-6 py-10 text-center',
        className
      )}
    >
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-border/70 bg-background/80">
        {badgeIcon}
      </div>
      <div className="space-y-2">
        <p className="text-lg font-semibold text-foreground">{title}</p>
        <p className="mx-auto max-w-xl text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="flex justify-center">
        <Button className="cursor-pointer gap-2" onClick={onPrimaryAction} disabled={isBusy}>
          {actionIcon}
          {primaryActionLabel}
        </Button>
      </div>
    </div>
  )
}
